/* COH Glas-Konfigurator – Logik. Fassung + Glas-Positionen werden gemeinsam in den Warenkorb gelegt. */
(function () {
  'use strict';
  var D = window.GC_DATA;
  var root = document.getElementById('gc');
  if (!D || !root) return;

  var prevFetch = window.fetch;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  function money(cents) {
    var v = cents / 100, txt;
    try {
      txt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
    } catch (e) { txt = v + ' €'; }
    /* Preis-Element für den Währungswechsel (App Doubly): Basis-Betrag in Cent, Basiswährung EUR */
    return '<span class="money" doubly-currency-eur="' + Math.round(cents) + '" doubly-currency="EUR">' + txt + '</span>';
  }
  var convTimer = null;
  function convertSoon() {
    clearTimeout(convTimer);
    convTimer = setTimeout(function () {
      try { if (typeof window.doublyChangeEvent === 'function') window.doublyChangeEvent(); } catch (e) { }
    }, 30);
  }
  /* Feste Preis-Texte (z. B. "350 €", "ab 149 €") einmalig als Preis-Element markieren, damit sie umgerechnet werden */
  function wrapStatic() {
    var re = /(\d{1,3}(?:\.\d{3})*|\d+)(?:,(\d{1,2}))?\s?€/g;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) {
      re.lastIndex = 0;
      if (/^(SCRIPT|STYLE|TEXTAREA|OPTION)$/.test(n.parentNode.nodeName)) continue;
      if (re.test(n.nodeValue) && !(n.parentNode.closest && n.parentNode.closest('.money'))) nodes.push(n);
      re.lastIndex = 0;
    }
    nodes.forEach(function (tn) {
      var html = '', last = 0, t = tn.nodeValue, m;
      re.lastIndex = 0;
      while ((m = re.exec(t))) {
        var euro = parseInt(m[1].replace(/\./g, ''), 10);
        var cent = m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0;
        html += esc(t.slice(last, m.index)) + '<span class="money" doubly-currency-eur="' + (euro * 100 + cent) + '" doubly-currency="EUR">' + esc(m[0]) + '</span>';
        last = m.index + m[0].length;
      }
      html += esc(t.slice(last));
      var sp = document.createElement('span');
      sp.innerHTML = html;
      var par = tn.parentNode;
      while (sp.firstChild) par.insertBefore(sp.firstChild, tn);
      par.removeChild(tn);
    });
    convertSoon();
  }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function dec(n) { return (n < 0 ? '-' : n > 0 ? '+' : '') + Math.abs(n).toFixed(2).replace('.', ','); }
  function one(n) { return n.toFixed(1).replace('.', ','); }

  /* ---------- Auswahlfelder füllen ---------- */
  function fill(id, values, placeholder, defVal) {
    var sel = document.getElementById(id);
    if (!sel) return;
    var h = '';
    if (placeholder) h += '<option value="">' + placeholder + '</option>';
    values.forEach(function (v) { h += '<option value="' + v.value + '"' + (defVal === v.value ? ' selected' : '') + '>' + v.label + '</option>'; });
    sel.innerHTML = h;
  }
  var sph = [], cyl = [], ax = [], pd = [], i;
  for (i = -600; i <= 600; i += 25) sph.push({ value: i === 0 ? '0,00' : dec(i / 100), label: i === 0 ? '0,00' : dec(i / 100) });
  for (i = -200; i <= 200; i += 25) cyl.push({ value: i === 0 ? '0,00' : dec(i / 100), label: i === 0 ? '0,00' : dec(i / 100) });
  for (i = 1; i <= 180; i++) ax.push({ value: String(i), label: i + '°' });
  for (i = 50; i <= 80; i++) pd.push({ value: one(i / 2), label: one(i / 2) });
  ['R', 'L'].forEach(function (e) {
    fill('gc_sph' + e, sph, 'Wählen', null);
    fill('gc_cyl' + e, cyl, null, '0,00');
    fill('gc_ax' + e, ax, '–', null);
    fill('gc_pd' + e, pd, '–', null);
  });
  var pct = [];
  for (i = 20; i <= 80; i += 10) pct.push({ value: String(i), label: i + ' %' });
  fill('gc_tpct', pct, 'Wählen', null);
  var dp = [];
  for (i = 80; i >= 30; i -= 10) dp.push({ value: String(i), label: 'oben ' + i + ' % · unten ' + (i - 15) + ' %' });
  fill('gc_dpct', dp, 'Wählen', null);

  /* ---------- Zustand ---------- */
  function val(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }
  function g(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function chk(id) { var el = document.getElementById(id); return !!(el && el.checked); }

  var GLAS = {
    s15: 'Standardglas 1,5, superentspiegelt',
    s16: 'Standardglas 1,6, superentspiegelt',
    muster: 'Nach Muster gefärbt (Angefertigtes Premium Glas 1,6, superentspiegelt)'
  };
  var TINT = { v30: 'Verlauf 30 % auf 0 %', v65: 'Verlauf 65 % auf 0 %', t75: 'Vollton 75 %', t85: 'Vollton 85 %' };

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var k = 0; k < forms.length; k++) {
      var pid = forms[k].querySelector('[name="product-id"]');
      if (pid && String(pid.value) === String(D.productId)) return forms[k];
    }
    return forms[0] || null;
  }
  function frameId() {
    var f = mainForm();
    var el = f && f.querySelector('[name="id"]');
    return el ? String(el.value) : '';
  }

  function state() {
    var color = root.querySelector('input[name="gc_color"]:checked');
    return {
      mode: val('gc_mode'), glas: val('gc_glas'), extra: val('gc_extra'),
      trans: val('gc_trans'), tint: val('gc_tint'), ttype: val('gc_ttype'), tpct: g('gc_tpct'), dpct: g('gc_dpct'),
      color: color ? color.value : '', colorGroup: color ? color.getAttribute('data-group') : '',
      rx: val('gc_rx')
    };
  }
  function tintLabel(s) {
    if (s.colorGroup === 'duo') {
      return s.dpct ? 'oben ' + s.dpct + ' % / unten ' + (Number(s.dpct) - 15) + ' %' : '';
    }
    if (s.colorGroup === 'sonder') {
      if (!s.ttype || !s.tpct) return '';
      return s.ttype === 'verlauf' ? 'Verlauf ' + s.tpct + ' % auf 0 %' : 'Vollton ' + s.tpct + ' %';
    }
    return s.tint ? TINT[s.tint] : '';
  }
  function isGlass() { return val('gc_mode') === 'glas'; }

  /* ---------- Abhängigkeiten ---------- */
  function setNone() {
    var n = root.querySelector('input[name="gc_extra"][value="none"]');
    if (n) n.checked = true;
  }
  function apply() {
    var s = state();
    var on = s.mode === 'glas';
    $('#gc_panel').hidden = !on;
    document.documentElement.classList.toggle('gc-on', on);
    if (!on) { render(); sync(); return; }

    var must = s.glas === 'muster';
    $('#gc_extras').hidden = must;
    if (must && s.extra !== 'none') setNone();
    $$('#gc_extras label.gc__opt[data-needs]').forEach(function (l) {
      var need = l.getAttribute('data-needs');
      var off = (need === 's16' && s.glas !== 's16') || (need === 'clear' && must);
      var inp = l.querySelector('input');
      l.classList.toggle('is-off', off);
      inp.disabled = off;
      if (off && inp.checked) setNone();
    });
    s = state();
    $('#gc_trans_panel').hidden = s.extra !== 'trans';
    $('#gc_tint_panel').hidden = s.extra !== 'tint';

    /* Intensität: feste Stufen (Standardfarben) oder frei wählbar (Sonder-/Duocolor) */
    $('#gc_steps_hint').hidden = !!s.color;
    $('#gc_std_steps').hidden = s.colorGroup !== 'std';
    $('#gc_free_steps').hidden = s.colorGroup !== 'sonder';
    $('#gc_duo_steps').hidden = s.colorGroup !== 'duo';

    /* Farbmuster: Verlauf- oder Vollton-Bild */
    var verlauf = s.tint === 'v30' || s.tint === 'v65';
    $$('.gc-sw img[data-voll]').forEach(function (im) {
      var want = verlauf && im.getAttribute('data-verlauf') ? im.getAttribute('data-verlauf') : im.getAttribute('data-voll');
      if (im.getAttribute('src') !== want) im.setAttribute('src', want);
    });

    /* Sehstärke */
    var rxOn = s.rx === 'yes';
    $('#gc_rx_panel').hidden = !rxOn;
    ['R', 'L'].forEach(function (e) {
      var c = g('gc_cyl' + e);
      var a = document.getElementById('gc_ax' + e);
      var needAx = c && c !== '0,00';
      a.disabled = !needAx;
      if (!needAx) a.value = '';
    });
    var unk = chk('gc_pd_unknown');
    ['gc_pdR', 'gc_pdL'].forEach(function (id) {
      var el = document.getElementById(id);
      el.disabled = unk;
      if (unk) el.value = '';
    });
    sync();
    render();
  }
  function sync() {
    $$('.gc__opt, .gc-sw, .gc__chip').forEach(function (l) {
      var inp = l.querySelector('input');
      if (inp) l.classList.toggle('is-on', inp.checked);
    });
  }

  /* ---------- Positionen & Preise ---------- */
  function lines() {
    var s = state();
    var out = [];
    if (s.mode !== 'glas') return out;
    var a = D.addons[s.glas];
    if (a && a.id) out.push({ id: a.id, price: a.price, label: GLAS[s.glas], kind: 'glas' });
    if (s.glas === 'muster') return out;
    if (s.extra === 'blue' && D.addons.blue.id) out.push({ id: D.addons.blue.id, price: D.addons.blue.price, label: 'Blaulichtfilter', kind: 'extra' });
    if (s.extra === 'trans' && D.addons.trans.id) out.push({ id: D.addons.trans.id, price: D.addons.trans.price, label: 'Selbsttönend (Transitions)' + (s.trans ? ', ' + s.trans : ''), kind: 'extra' });
    if (s.extra === 'tint') {
      var sonder = s.colorGroup === 'sonder' || s.colorGroup === 'duo';
      var t = sonder ? D.addons.tintSonder : D.addons.tint;
      if (t && t.id) out.push({ id: t.id, price: t.price, label: 'Tönung' + (tintLabel(s) ? ', ' + tintLabel(s) : '') + (s.color ? ', ' + s.color : ''), kind: 'extra' });
    }
    return out;
  }
  function render() {
    var box = $('#gc_lines');
    if (!box) return;
    var s = state();
    if (s.mode !== 'glas') { box.innerHTML = ''; $('#gc_eta').textContent = ''; return; }
    var fv = D.variants[frameId()];
    var fp = fv ? fv.price : 0;
    var ls = lines();
    var total = fp;
    var h = '<div class="gc__line"><span>Fassung</span><span>' + money(fp) + '</span></div>';
    ls.forEach(function (l) {
      total += l.price;
      h += '<div class="gc__line"><span>' + l.label + '</span><span>+ ' + money(l.price) + '</span></div>';
    });
    h += '<div class="gc__line gc__line--total"><span>Gesamt</span><span>' + money(total) + '</span></div>';
    box.innerHTML = h;
    convertSoon();
    $('#gc_eta').textContent = etaText(s) + ' Der Versand erfolgt gemeinsam, sobald alles fertig ist.';
  }
  function etaText(s) {
    return s.glas === 'muster' ? 'Lieferzeit ca. 14–21 Werktage.' : 'Lieferzeit ca. 7 Werktage.';
  }

  /* ---------- Prüfung ---------- */
  function validate() {
    var s = state();
    var e = [];
    if (s.mode !== 'glas') return e;
    if (s.extra === 'trans' && !s.trans) e.push('Bitte wählen Sie die Farbe der selbsttönenden Gläser (Grau oder Braun).');
    if (s.extra === 'tint') {
      if (!s.color) e.push('Bitte wählen Sie eine Tönungsfarbe.');
      else if (s.colorGroup === 'std' && !s.tint) e.push('Bitte wählen Sie die Tönungsstufe.');
      else if (s.colorGroup === 'sonder' && (!s.ttype || !s.tpct)) e.push('Bitte wählen Sie Vollton oder Verlauf und die Intensität.');
      else if (s.colorGroup === 'duo' && !s.dpct) e.push('Bitte wählen Sie die Intensität der Duocolor-Tönung.');
    }
    if (s.rx === 'yes') {
      if (!g('gc_sphR') || !g('gc_sphL')) e.push('Bitte geben Sie die Sphäre für beide Augen an.');
      ['R', 'L'].forEach(function (x) {
        var c = g('gc_cyl' + x);
        if (c && c !== '0,00' && !g('gc_ax' + x)) e.push('Bitte geben Sie die Achse für das ' + (x === 'R' ? 'rechte' : 'linke') + ' Auge an.');
      });
      if (!chk('gc_pd_unknown') && (!g('gc_pdR') || !g('gc_pdL'))) e.push('Bitte geben Sie die Pupillendistanz an oder markieren Sie „PD unbekannt“.');
      if (!chk('gc_consent')) e.push('Bitte bestätigen Sie die Einwilligung zur Verarbeitung Ihrer Sehstärke-Angaben.');
    }
    if (!chk('gc_ack')) e.push('Bitte bestätigen Sie den Hinweis zum Ausschluss des Widerrufsrechts bei Gläsern nach Maß.');
    return e;
  }
  function markInvalid(e) {
    $$('.gc-invalid').forEach(function (x) { x.classList.remove('gc-invalid'); });
    var first = null;
    function mark(el) { if (!el) return; el.classList.add('gc-invalid'); if (!first) first = el; }
    function lab(id) { var el = document.getElementById(id); return el ? (el.closest('label') || el) : null; }
    e.forEach(function (m) {
      if (/Glasform/.test(m)) mark($('#gc_shapes'));
      else if (/Transitions|selbstt/i.test(m)) mark($('#gc_trans_panel'));
      else if (/Tönung|Vollton|Duocolor/.test(m)) mark($('#gc_tint_panel'));
      else if (/Sphäre/.test(m)) { ['R', 'L'].forEach(function (x) { if (!g('gc_sph' + x)) mark(document.getElementById('gc_sph' + x)); }); }
      else if (/Achse/.test(m)) { var x2 = /rechte/.test(m) ? 'R' : 'L'; mark(document.getElementById('gc_ax' + x2)); }
      else if (/Pupillendistanz/.test(m)) { ['R', 'L'].forEach(function (x) { if (!g('gc_pd' + x)) mark(document.getElementById('gc_pd' + x)); }); }
      else if (/Einwilligung/.test(m)) mark(lab('gc_consent'));
      else if (/Widerruf/.test(m)) mark(lab('gc_ack'));
    });
    return first;
  }
  function showErrors(e, noScroll) {
    var box = $('#gc_err');
    var first = markInvalid(e);
    if (!e.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = '<ul>' + e.map(function (m) { return '<li>' + m + '</li>'; }).join('') + '</ul>';
    box.hidden = false;
    if (noScroll) return;
    /* Zum ersten fehlerhaften Feld springen, die Liste bleibt unter dem Button stehen */
    try { (first || box).scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) { }
  }

  /* ---------- Eigenschaften für den Warenkorb ---------- */
  function rxText(e) {
    var c = g('gc_cyl' + e);
    var t = 'SPH ' + g('gc_sph' + e);
    if (c && c !== '0,00') t += ' · CYL ' + c + ' · ACH ' + g('gc_ax' + e) + '°';
    return t;
  }
  function frameProps(base, s, group) {
    var p = {};
    Object.keys(base).forEach(function (k) { p[k] = base[k]; });
    p['Lieferzeit'] = etaText(s).replace('Lieferzeit ', '').replace(/\.$/, '');
    p['Gläser'] = GLAS[s.glas];
    if (s.extra === 'blue') p['Veredelung'] = 'Blaulichtfilter';
    if (s.extra === 'trans') p['Veredelung'] = 'Selbsttönend (Transitions), ' + s.trans;
    if (s.extra === 'tint') p['Veredelung'] = 'Tönung ' + tintLabel(s) + ', ' + s.color;
    if (s.glas === 'muster') p['Hinweis'] = 'Original-Glas der Fassung wird zum Färben eingesendet';
    if (s.rx === 'yes') {
      p['Sehstärke rechts'] = rxText('R');
      p['Sehstärke links'] = rxText('L');
      p['PD'] = chk('gc_pd_unknown') ? 'unbekannt, Messhilfe per E-Mail' : ('R ' + g('gc_pdR') + ' · L ' + g('gc_pdL'));
      p['_einwilligung_sehstaerke'] = 'ja';
    } else {
      p['Sehstärke'] = 'ohne (Planglas)';
    }
    p['_glas_gruppe'] = group;
    p['_glas_rolle'] = 'frame';
    return p;
  }
  function uid() { return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

  window.GC_API = { state: state, lines: lines, validate: validate, showErrors: showErrors, frameProps: frameProps, isGlass: isGlass, uid: uid };

  /* ---------- Platzierung über dem Kaufbutton ---------- */
  function place() {
    var pf = document.querySelector('product-form');
    if (!pf || !pf.parentNode) return;
    if (root.nextElementSibling !== pf || root.parentNode !== pf.parentNode) pf.parentNode.insertBefore(root, pf);
    if (root.hidden) root.hidden = false;
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; place(); });
  }).observe(document.body, { childList: true, subtree: true });
  place();

  root.addEventListener('change', function (ev) {
    if (ev.target && ev.target.id === 'gc_pd_unknown') { }
    apply();
    var e = $('#gc_err');
    if (e && !e.hidden) showErrors(validate(), true);
  });

  var lastId = frameId();
  setInterval(function () {
    var cur = frameId();
    if (cur !== lastId) { lastId = cur; render(); }
  }, 500);

  apply();
  wrapStatic();
})();
